export default "__VITE_ASSET__DF3Ykpgr__"